const ENDPOINT = '/v1/debug/errors'
const ENABLED  = import.meta.env.VITE_DEBUG_REPORTING === 'true'

type ErrorType = 'console_error' | 'unhandled_rejection' | 'error_boundary' | 'network_error'

function send(type: ErrorType, message: string, stack?: string, context?: Record<string, unknown>) {
  if (!ENABLED) return
  const payload = { type, message: message.slice(0, 2000), stack: stack?.slice(0, 5000), url: location.href, context }
  if ('sendBeacon' in navigator) {
    navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(payload)], { type: 'application/json' }))
  } else {
    fetch(ENDPOINT, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {})
  }
}

export function installErrorReporter() {
  if (!ENABLED) return

  // 1. Console errors
  const origError = console.error.bind(console)
  console.error = (...args: unknown[]) => {
    origError(...args)
    const msg = args.map(a => (typeof a === 'string' ? a : a instanceof Error ? a.message : JSON.stringify(a))).join(' ')
    const stack = args.find(a => a instanceof Error) instanceof Error
      ? (args.find(a => a instanceof Error) as Error).stack
      : undefined
    send('console_error', msg, stack)
  }

  // 2. Unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason
    const msg = reason instanceof Error ? reason.message : String(reason)
    send('unhandled_rejection', msg, reason instanceof Error ? reason.stack : undefined)
  })

  // 3. Global JS errors
  window.addEventListener('error', (e) => {
    send('console_error', e.message, e.error?.stack, { filename: e.filename, line: e.lineno, col: e.colno })
  })
}

export function reportBoundaryError(error: Error, info: { componentStack: string }) {
  send('error_boundary', error.message, error.stack, { componentStack: info.componentStack })
}
